var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M15.975 4C14.3906 4 12.9375 4.74063 12 5.95938C11.0625 4.74063 9.60938 4 8.025 4C5.25469 4 3 6.26406 3 9.04844C3 10.3562 3.49688 11.5984 4.40156 12.5453L11.4891 19.7031L12 20.2188L12.5109 19.7031L19.4625 12.6813C20.4469 11.7297 21 10.4359 21 9.04844C21 6.26406 18.7453 4 15.975 4Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }